export default __webpack_public_path__ + "static/media/smedetoften-property-04.3020d8ba.jpg";